import { postRequest } from '../libs/AxiosService.util';

export async function serviceFetchJobs(params) {
    return await postRequest('jobs', params);
}

export async function serviceGetJobDetail(params) {
    return await postRequest('/job/detail', params);
}

export async function serviceDownloadJobsExcel(params) {
    return await postRequest('/jobs/download', params);
}

export async function serviceJobApplications(params){
    return await postRequest('/my/job/applications',params)
}

export async function serviceGetJobTimeline(params){
    return await postRequest('/job/timeline',params)
}

export async function serviceJobPayments(params){
    return await postRequest('/jobs/payment',params)
}

export async function serviceJobPayouts(params){
    return await postRequest('/jobs/payout',params)
}

export async function serviceJobRatings(params){
    return await postRequest('/jobs/rating',params)
}

export async function serviceRejectJobApplication(params) {
    return await postRequest('job/applications/reject', params);
}

export async function serviceUnpublishJob(params) {
    return await postRequest('job/unpublish', params);
}

